import { EmployeeColumnFilterValueProps } from "@/pages/employees/index/employee-column-filter-renderers.ts";
import { Button, Input, Modal, ModalProps, Stack, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function EmployeeColumnNumberRangeModal({
  column,
  filter,
  onChange,
  ...props
}: ModalProps & EmployeeColumnFilterValueProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const [from, setFrom] = useState(filter.number_from?.toString() ?? "");
  const [to, setTo] = useState(filter.number_to?.toString() ?? "");
  const numberFrom = from === "" ? undefined : Number(from);
  const numberTo = to === "" ? undefined : Number(to);
  const invalid =
    (numberFrom !== undefined && !Number.isFinite(numberFrom)) ||
    (numberTo !== undefined && !Number.isFinite(numberTo)) ||
    (numberFrom !== undefined && numberTo !== undefined && numberFrom > numberTo);

  return (
    <Modal
      {...props}
      title={column.title}
      withCloser
      actions={
        <Stack gap="sm">
          <Button
            size="lg"
            disabled={invalid}
            onClick={() => {
              onChange({ number_from: numberFrom, number_to: numberTo });
              close(props.id);
            }}
          >
            {t("common:save")}
          </Button>
          <Button size="lg" variant="plain" onClick={() => close(props.id)}>
            {t("common:cancel")}
          </Button>
        </Stack>
      }
    >
      <div className="grid grid-cols-2 gap-sm [&>*]:min-w-0">
        <Input
          type="number"
          step="any"
          label={t("common:number_from_short")}
          value={from}
          onChange={(event) => setFrom(event.currentTarget.value)}
        />
        <Input
          type="number"
          step="any"
          label={t("common:number_to_short")}
          value={to}
          error={invalid ? t("core:column_filter_range_invalid") : undefined}
          onChange={(event) => setTo(event.currentTarget.value)}
        />
      </div>
    </Modal>
  );
}
